export class ResumeStorage {
  private static KEY = 'ResumeData';

  static getResume(): any {
    try {
      const data = localStorage.getItem(this.KEY);
      return data ? JSON.parse(data) : {};
    } 
    catch (e) {
      console.error('Error parsing Resume', e);
      return {};
    }
  }

  static saveResume(resume: any): void {
    localStorage.setItem(this.KEY, JSON.stringify(resume));
  }

  static exists(): boolean {
    return localStorage.getItem(this.KEY) !== null;
  }

  static clear(): void {
    localStorage.removeItem(this.KEY);
  }
}